export const getFormattedNow = () => {
  const now = new Date();

  const formattedTime = now.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return formattedTime;
};

export function calcularPesoCubico(comprimento: number, largura: number, altura: number): number {
  if (!comprimento || !largura || !altura) return 0;
  return (comprimento * largura * altura) / 6000;
}

export const removeEmptyFields = <T extends Record<string, unknown>>(obj: T): T => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, v]) => v !== '' && v !== null && v !== undefined)
      .map(([k, v]) => [
        k,
        typeof v === 'object' && v !== null && !Array.isArray(v)
          ? removeEmptyFields(v as Record<string, unknown>)
          : v,
      ])
  ) as T;
};

export function splitNotaFiscal(value: string) {
  if (value.includes('-')) {
    const [chave, serie] = value.split('-');
    return {
      chave,
      serie,
    };
  } else {
    const chave = value.substring(0, 2);
    const serie = value.substring(2);
    return {
      chave,
      serie,
    };
  }
}
